<section class="my-4 shadow border rounded-3 bg-white overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <h5 class="m-0">Публични коментари</h5>
  </header>
  @if (adComments.length == 0) {
    <main class="p-3 border-bottom">
      <p class="m-0">
        Няма добавени коментари.
      </p>
    </main>
  }
  <ul class="m-0 list-unstyled">
    @for (adComment of adComments; track adComment.adCommentId) {
      <li class="border-bottom">
        <header class="d-flex justify-content-between">
          <h6 class="px-3 pt-3 d-flex justify-content-between align-items-center">
            <a class="me-2 btn-link text-decoration-none"
               [routerLink]="[appRoutes.root, appRoutes.profile, adComment.userId]">
              {{ adComment.username }}
            </a>
            <nz-user-rating [rating]="adComment.userRating"></nz-user-rating>
          </h6>
          @if (adComment.isUserAuthor) {
            <div class="dropdown">
              <button type="button"
                      data-bs-toggle="dropdown"
                      aria-label="Опции"
                      aria-expanded="false"
                      class="btn btn-light text-muted dropdown-button">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                <li>
                  <button class="dropdown-item"
                          (click)="onOpenAdCommentModal(adComment)">
                    <i class="dropdown-item-icon text-muted fa-solid fa-pen-to-square" aria-hidden="true"></i>
                    Редактиране на коментар
                  </button>
                </li>
                <hr class="dropdown-divider">
                <li>
                  <button class="dropdown-item text-danger"
                          (click)="onDeleteComment(adComment.adCommentId)">
                    <i class="dropdown-item-icon fa-solid fa-trash-can" aria-hidden="true"></i>
                    Изтриване на коментар
                  </button>
                </li>
              </ul>
            </div>
          }
        </header>
        <p class="px-3"
           [style.white-space]="'pre-line'">
          {{ adComment.content }}
        </p>
        <div class="px-3 pb-3 small text-muted text-end">
          {{ adComment.dateTime | date: 'dd:MM:yyyy г., HH:mm ч.' }}
        </div>
      </li>
    }
  </ul>
  <footer class="bg-light p-3">
    <div class="row g-3 justify-content-end">
      <div class="col-12 col-sm-6 col-md-5 col-xl-3">
        <button
          type="button"
          name="Добави коментар"
          class="w-100 btn btn-nz-primary"
          [disabled]="isUserBlocked"
          (click)="onOpenAdCommentModal()">
          <i class="fa-solid fa-plus-circle" aria-hidden="true"></i>
          <span class="ms-2">Добави коментар</span>
        </button>
      </div>
    </div>
  </footer>
</section>
